<template>
	<div class="login">
        <reg-input
            :textpl="info.holderInput"
            :pattern="info.patternInput"
            :value="info.value"
            :valid="false"
            :active="info.active"
            @input="onInput($event)">
        </reg-input>
        <reg-input-pass
            :textpl="pass.holderInput"
            :pattern="pass.patternInput"
            :value="pass.value"
            :valid="false"
            @input="onInputPass($event)"></reg-input-pass>
        <div class="loginButton" @click="onLogin">
            <div class="loginButton-wrap">
                <div v-show="!loading" class="loginButton-title">войти</div>
                <preloader v-show="loading" :styles="loaderStyle"></preloader>
            </div>
        </div>
        <div v-if="getError.length !== 0" class="errorMessage color-red">Непарвильная пара ЛОГИН/ПАРОЛЬ</div>
        <div v-if="getError.length !== 0" class="remember_pass">Забыли пароль?</div>
        <reg-input v-if="getError.length !== 0"
            :textpl="repair.holderInput"
            :pattern="repair.patternInput"
            :value="repair.value"
            :valid="true"
            :active="repair.active"
            @input="onInputRepair($event)">
        </reg-input>
        <div class="loginButton" @click="sendPass()" v-if="repair.valid">
            <div class="loginButton-wrap">
                <div v-show="!loading" class="loginButton-title">отправить пароль на почту</div>
                <preloader v-show="loading" :styles="loaderStyle"></preloader>
            </div>
        </div>
        <div v-if="status" class="remember_pass color-green">Пароль был отправлен Вам на почту.</div>
        <div v-if="errorStatus" class="remember_pass color-red">Учетной записи с таким логином не найдено или почта недействительна.</div>
	</div>
</template>

<script>

import RegInput from '../ui-components/reg-input'
import RegInputPass from '../ui-components/reg-input-pass'
import Loader from '../ui-components/preloader'
import { mapGetters, mapMutations } from 'vuex';
import { setTimeout } from 'timers';
import axios from 'axios';

	export default {
		components: {
            'reg-input': RegInput,
            'reg-input-pass':RegInputPass,
            'preloader':Loader
	    },
		props: [],
		data() {
			return {
                info:
                    {
                        holderInput: 'Элекронная почта',
                        patternInput: /.+/,
                        value: '',
                        active:false
                    },
                repair: {
                        holderInput: 'Электронная почта',
                        patternInput: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        valid:false,
                        value:'',
                        active:false
                },
                pass:
                    {
                       holderInput: 'Пароль',
                       patternInput: /.+/,
                       value:'',
                       active:false
                    },
                errorMessage:'Неправильная пара ЛОГИН/ПАРОЛЬ',
                status:false,
                errorStatus:false,
                validError:false,
                loading:false,
                loaderStyle: {width:30 + 'px',height:30 + 'px'}
			};
		},
		computed: {
		...mapGetters ({
            getError:'auth/getErrorMessage',
            getRestApiUri:'api/getApiUri'
        })
		},
		methods: {
            onInput(data) {
                this.info.value= data.value;
                this.info.active = data.activated;
            },
            onInputRepair(data) {
                this.repair.value = data.value;
                this.repair.active = data.activated;
                this.repair.valid = data.completed;
            },
            onInputPass(data) {
                this.pass.value = data.value;
                this.pass.active = data.activated;
            },
            sendPass() {
                this.loading = true;
                axios
                    .get(this.getRestApiUri + 'email?login=' + this.repair.value + '&type=repair')
                    .then(response => {
                        if(response.data === 'success') {
                            this.repair.value = '';
                            this.status = true;
                            this.errorStatus = false;
                        } else {
                            this.status = false;
                            this.errorStatus = true;
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                    });
            },
            async onLogin() {
                this.loading = true;
                let payload = { Login: this.info.value, Password: this.pass.value };
                await this.$store.dispatch('auth/performLogin', payload);
                    this.loading = false;
                    this.$store.dispatch('chat/logout');
                    this.$store.dispatch('chat/connectWithCreds', {
                        login: payload.Login,
                        password: payload.Password
                    });
                    this.validError = !this.validError;
            }
        },
        watch: {
            getError: function(value) {
                if(value === 'succes')
                    this.$emit('closeform', false);
            }
        },
        mounted() {
            this.$store.commit('auth/clearError');
        }
	}
</script>

<style lang="less" scoped>
.login {
    margin-top:24px;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
input[type="text"] {
    margin-top:12px;
    width: 356px;
    border-radius: 4px;
    line-height: normal;
    font-family: Arimo;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    box-sizing: border-box;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    color: #ffffff;
    background-color: #374b62;
    border: solid 1px #718da8;
    padding: 18px 12px;
    text-align: left;
    outline: none;
        &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #adc4e1;
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.7;
            text-transform: uppercase;
            letter-spacing: 0.4px;
            opacity: 1; /* Firefox */
        }
        &::-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #adc4e1;
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.7;
            text-transform: uppercase;
            letter-spacing: 0.4px;
        }
        &::-ms-input-placeholder { /* Microsoft Edge */
            color: #adc4e1;
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.7;
            text-transform: uppercase;
            letter-spacing: 0.4px;
        }
        &:hover {
            border: solid 1px #cae9ff;
        }
        &:focus {
            border: solid 1px #cae9ff;
        }
}
input[type="password"] {
    margin-top:12px;
    width: 356px;
    border-radius: 4px;
    background-color: #374b62;
    border: solid 1px #718da8;
    padding: 18px 12px;
    font-family: Arimo;
    font-size: 11px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    text-align: left;
    color: #adc4e1;
    text-transform: uppercase;
    outline: none;
    box-sizing: border-box;
    &:hover {
        border: solid 1px #cae9ff;
    }
    &:focus {
        border: solid 1px #cae9ff;
    }
}
.loginButton {
    height: 48px;
    min-width: 356px;
    border-radius: 4px;
    margin-bottom: 50px;
    background-color: #0fd7b7;
    border: none;
    margin-top: 12px;
    color:#374b62;
    cursor: pointer;
    font-family: Arimo;
    font-size: 13px;
    font-weight: bold;
    &-wrap {
        margin: auto;
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
    }
    &-title {
        position: absolute;
    }
    &:disabled {
        background-color: #718da8;
        &:hover {
            background-color: #718da8;
        }
    }
    &:hover {
        background-color: @colors[green];
    }
}
.remember_pass {
    cursor: pointer;
    font-family: Arimo;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    text-align: left;
    color: #adc4e1;
    margin-top: 0px;
    padding: 6px;
    width: 356px;
    text-align: center;
}
.errorMessage {
    font-family: Arimo;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.4px;
    text-align: left;
    color: #adc4e1;
    margin-top: 0px;
}
.error {
    border: solid 1px #ff9292 !important;
}

.succes {
    border: solid 1px @colors[green] !important;
}

</style>
